module.exports = __webpack_public_path__ + "img/arrow.3d900992.svg";